export const DOCUMENT_COMPARE = 'DOCUMENT_COMPARE';
export const DOCUMENT_COMPARE_RE_ANALYSIS = 'DOCUMENT_COMPARE_RE_ANALYSIS';
export const GET_SAVED_COMPARISON = 'GET_SAVED_COMPARISON';
export const GET_SHARED_COMPARISON = 'GET_SHARED_COMPARISON';
export const DELETE_COMPARISON = ' DELETE_COMPARISON';
export const RENAME_TITLE = 'RENAME_TITLE';
export const ADD_REMOVE_BOOKMARK = 'ADD_REMOVE_BOOKMARK';
